cbp-tab-panel {
  display: none;

  &[selected]{
    display: block;
  }
}
